import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=077b5401&scoped=true&"
import script from "./Price.vue?vue&type=script&lang=js&"
export * from "./Price.vue?vue&type=script&lang=js&"
import style0 from "./Price.vue?vue&type=style&index=0&id=077b5401&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077b5401",
  null
  
)

component.options.__file = "Price.vue"
export default component.exports